import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const VisualisedState = (state: RootState) => state.weeklyPlanner.visualise;

export const selectAllVisualised = (state: RootState) => VisualisedState(state).rows;
export const selectVisualiseLoading = (state: RootState) => VisualisedState(state).loading;

export const selectVisualisedWorker = createSelector(
  [selectAllVisualised, (_: RootState, userId: number) => userId],
  (rows, userId) => {
    const row = rows.find(({ id }) => Number(id) === userId);
    return row || null;
  },
);
